function isValidString(value: any): boolean {
    return typeof value === 'string' && value.trim().length > 0;
}

export default isValidString
